import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

import salesDood2 from "../utils/salesDood2.png";
import axios from "axios";

Font.register({
  family: "Manrope",
  fonts: [
    {
      src: "/fonts/Manrope-Regular.ttf", // Regular weight
      fontWeight: "normal",
    },
    {
      src: "/fonts/Manrope-Bold.ttf", // Bold weight
      fontWeight: "bold",
    },
    {
      src: "/fonts/Manrope-Medium.ttf", // Medium weight
      fontWeight: 500,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Manrope",
  },
  // reserved blank space at the very top for letterhead
  headerSpace: {
    height: 80, // adjust height of reserved space
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    marginBottom: 10,
  },
  headerRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 18,
    marginBottom: 18,
  },
  smallText: {
    fontSize: 9,
    color: "grey",
  },
  customerDetails: {
    marginTop: 8,
  },
  customerName: {
    fontSize: 11,
    fontWeight: "bold",
  },
  accountDetails: {
    textAlign: "center",
  },
  logo: {
    width: 70,
    height: 20,
    marginBottom: 8,
  },
  mainTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4,
    textAlign: "center",
  },
  currencyDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "items-center",
    textAlign: "center",
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 2,
  },
  summaryBox: {
    paddingBottom: 8,
    borderBottom: "1px solid #ccc",
  },
  transactionRow: {
    flexDirection: "row",
    borderBottom: "1px solid #eee",
    // paddingVertical: 6,
  },
  tid: {
    fontSize: 9,
    fontWeight: "bold",
  },
  ref: {
    fontSize: 9,
    color: "grey",
  },
  cell: {
    fontSize: 10,
  },
  cellCredit: {
    color: "green",
    fontWeight: "bold",
  },
  cellDebit: {
    color: "red",
    fontWeight: "bold",
  },
  footerRow: {
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40,
    flexDirection: "row",
    justifyContent: "space-between",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
    paddingTop: 6,
  },
  footer: {
    fontSize: 9,
    color: "grey",
  },
  pageNumber: {
    fontSize: 9,
    color: "grey",
  },
});

const VoucherDocument = ({
  voucherAccountData,
  voucherNoFromAPI,
  voucherTypeFromAPI,
  voucherDateFromAPI,
}) => {
  console.log("🚀 ~ VoucherDocument ~ voucherDateFromAPI:", voucherDateFromAPI);
  console.log("voucherAccountData from documnet::", voucherAccountData);

  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  //     const totalAmount = voucherAccountData?.reduce(
  //   (sum, t) => sum + (parseFloat(t.amount) || 0),
  //   0
  // );

  const [voucherTypes, setVoucherTypes] = useState([]);

  useEffect(() => {
    const fetchVoucherTypes = async () => {
      try {
        const COMPANY_CODE = localStorage.getItem("companyCode");
        const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");
        let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
          ? JSON.parse(localStorage.getItem("apiPaths"))
          : "-";
        const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/VOUCHER/-/-`;
        const res = await axios.get(url);
        setVoucherTypes(res.data || []);
      } catch {
        setVoucherTypes([]);
      }
    };
    fetchVoucherTypes();
  }, []);

  const getVoucherTitle = (type) => {
    const match = voucherTypes.find((v) =>
      type?.toUpperCase().startsWith(v.VTYPE),
    );
    return match?.VDESCRIPTION || `${type?.toUpperCase() || ""} VOUCHER`;
  };

  const debitTotal = voucherAccountData
    ?.filter((t) => t.accountype === "D" || t.type === "D")
    ?.reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0);

  const creditTotal = voucherAccountData
    ?.filter((t) => t.accountype === "C" || t.type === "C")
    ?.reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Reserved header space for letterhead */}
        <View style={styles.headerSpace} fixed>
          {apiPaths_from_local_storage[0].REP_HEADER.includes("data:image/") ? (
            <Image
              src={apiPaths_from_local_storage[0].REP_HEADER}
              style={styles.header_image}
            />
          ) : null}
        </View>

        {/* Header (below letterhead space) */}
        <Text style={styles.mainTitle}>{getVoucherTitle(voucherTypeFromAPI)}</Text>
        <View style={styles.headerRow}>
          <Text style={styles.sectionTitle}>
            Voucher Type: {voucherTypeFromAPI}
          </Text>
          <Text style={styles.sectionTitle}>
            Voucher No: {voucherNoFromAPI}
          </Text>
          <Text style={styles.sectionTitle}>
            Voucher Date: {voucherDateFromAPI}
          </Text>
          {/* <Text style={styles.smallText}>Statement Period</Text> */}
          {/* <Text style={styles.smallText}>Statement Period</Text> */}
        </View>

        {/* Transactions Header */}
        <View
          style={[
            styles.transactionRow,
            { backgroundColor: "#f0f0f0", paddingVertical: 4 },
          ]}
        >
          <Text
            style={[
              styles.cell,
              { flex: 1, fontWeight: "bold", paddingHorizontal: "6px" },
            ]}
          >
            Account
          </Text>
          <Text style={[styles.cell, { flex: 1.5, fontWeight: "bold" }]}>
            Description
          </Text>
          <Text
            style={[
              styles.cell,
              { flex: 1, fontWeight: "bold", textAlign: "center" },
            ]}
          >
            Reference
          </Text>
          <Text
            style={[
              styles.cell,
              { flex: 1, fontWeight: "bold", textAlign: "center" },
            ]}
          >
            Details
          </Text>
          <Text
            style={[
              styles.cell,
              { flex: 1, fontWeight: "bold", textAlign: "right" },
            ]}
          >
            Job Code
          </Text>
          {/* <Text
            style={[
              styles.cell,
              {
                flex: 1,
                fontWeight: "bold",
                textAlign: "right",
                marginRight: "4px",
              },
            ]}
          >
            Currency
          </Text> */}
          <Text
            style={[
              styles.cell,
              {
                flex: 1,
                fontWeight: "bold",
                textAlign: "right",
                marginRight: "4px",
              },
            ]}
          >
            Debit
          </Text>
          <Text
            style={[
              styles.cell,
              {
                flex: 1,
                fontWeight: "bold",
                textAlign: "right",
                marginRight: "4px",
              },
            ]}
          >
            Credit
          </Text>
        </View>

        {/* Transactions Loop */}

        <View>
          {voucherAccountData?.map((t, idx) => (
            <View
              key={idx}
              style={[styles.transactionRow, { paddingVertical: 4 }]}
            >
              <Text
                style={[
                  styles.cell,
                  { flex: 1, textAlign: "left", paddingLeft: 4 },
                ]}
              >
                {t.account || "-"}
              </Text>
              <Text style={[styles.cell, { flex: 1.5 }]}>
                {t.ACCDESC || "-"}
              </Text>
              <Text style={[styles.cell, { flex: 1, textAlign: "center" }]}>
                {t.ref || "-"}
              </Text>
              <Text style={[styles.cell, { flex: 1, textAlign: "center" }]}>
                {t.entry_ref || "-"}
              </Text>
              <Text
                style={[
                  styles.cell,
                  { flex: 1, textAlign: "center", marginLeft: 4 },
                ]}
              >
                {t.job_code || "-"}
              </Text>
              {/* <Text style={[styles.cell, { flex: 1, textAlign: "right", marginRight: 4 }]}>
        {t.amount || "-"}
      </Text> */}

              {/* ✅ Debit */}
              <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
                {t.accountype === "D" || t.type === "D"
                  ? t.amount.toFixed(2)
                  : "-"}
              </Text>

              {/* ✅ Credit */}
              <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
                {t.accountype === "C" || t.type === "C"
                  ? t.amount.toFixed(2)
                  : "-"}
              </Text>
            </View>
          ))}

          {/* Total Row */}
          <View
            style={[
              styles.transactionRow,
              {
                // borderTopWidth: 1,
                // borderTopColor: "#ccc",
                // marginTop: 5,
                // paddingTop: 4,
                paddingVertical: 4,
              },
            ]}
          >
            <Text
              style={[
                styles.cell,
                { flex: 5.5, textAlign: "right", fontWeight: "bold" },
              ]}
            >
              Total:
            </Text>
            <Text
              style={[
                styles.cell,
                { flex: 1, textAlign: "right", fontWeight: "bold" },
              ]}
            >
              {/* {totalAmount.toFixed(2)} */}
              {debitTotal.toFixed(2)}
            </Text>
            <Text
              style={[
                styles.cell,
                { flex: 1, textAlign: "right", fontWeight: "bold" },
              ]}
            >
              {creditTotal.toFixed(2)}
            </Text>
          </View>
        </View>

        {/* Signature Section */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 40,
            paddingHorizontal: 20,
          }}
        >
          <View style={{ width: "40%" }}>
            <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 4 }}>
              Prepared By
            </Text>
            <Text style={{ fontSize: 10, marginBottom: 30 }}>
              _________________________
            </Text>
            {/* <Text style={{ fontSize: 9, color: "grey" }}>Date: ________</Text> */}
          </View>
          <View style={{ width: "40%" }}>
            <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 4 }}>
              Received By
            </Text>
            <Text style={{ fontSize: 10, marginBottom: 30 }}>
              _________________________
            </Text>
            {/* <Text style={{ fontSize: 9, color: "grey" }}>Date: ________</Text> */}
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footerRow}>
          {/* <Text style={styles.footer}>Copyright © MTBS.co 2025</Text> */}
          <Text
            style={styles.pageNumber}
            render={({ pageNumber }) => `Page ${pageNumber}`}
            fixed
          />
        </View>
      </Page>
    </Document>
  );
};

export default VoucherDocument;
